/* ── AppSupertools Subscriptions module ──────────────────── */
(function(){
  'use strict';

  var SUB_VIEW = 'monthly';

  function pid(){ return (window.astWsPid && window.astWsPid()) || null; }
  function getP(projectId){ return window.astGetWs ? window.astGetWs(projectId) : null; }

  function getSubs(projectId){
    var p = getP(projectId);
    if(!p) return [];
    if(!Array.isArray(p.workspace.subscriptions)) p.workspace.subscriptions = [];
    return p.workspace.subscriptions;
  }
  function saveSubs(projectId, subs){
    var p = getP(projectId);
    if(!p) return;
    p.workspace.subscriptions = subs;
    if(window.astSaveWs) window.astSaveWs(projectId, p.workspace);
  }

  function monthlyPrice(item){
    var v = parseFloat(item.price) || 0;
    return item.cycle === 'annual' ? v / 12 : v;
  }
  function annualPrice(item){
    var v = parseFloat(item.price) || 0;
    return item.cycle === 'monthly' ? v * 12 : v;
  }
  function formatPrice(num){
    if(num === 0) return '$0';
    if(num % 1 === 0) return '$' + num;
    return '$' + num.toFixed(2);
  }
  function displayPrice(item){
    return SUB_VIEW === 'annual'
      ? formatPrice(annualPrice(item)) + '/yr'
      : formatPrice(monthlyPrice(item)) + '/mo';
  }
  function totalDisplay(subs){
    var total = 0;
    subs.forEach(function(s){ total += SUB_VIEW === 'annual' ? annualPrice(s) : monthlyPrice(s); });
    return formatPrice(Math.round(total * 100) / 100) + (SUB_VIEW === 'annual' ? '/yr' : '/mo');
  }
  function faviconUrl(url){
    try{
      var domain = new URL(url).hostname;
      return 'https://www.google.com/s2/favicons?domain=' + domain + '&sz=32';
    } catch(e){ return ''; }
  }
  function esc(s){ return String(s || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;'); }

  /* ── render list + header meta ── */
  function renderSubs(projectId){
    var container = document.getElementById('ast-subs-container');
    if(!container || !projectId) return;
    var subs = getSubs(projectId);
    var view = SUB_VIEW === 'annual' ? 'annual' : 'monthly';
    var filtered = subs.filter(function(s){ return (s.cycle === 'annual' ? 'annual' : 'monthly') === view; });

    var viewTotal = 0;
    filtered.forEach(function(s){ viewTotal += parseFloat(s.price) || 0; });
    var badge = document.getElementById('ast-subs-total-badge');
    if(badge) badge.textContent = filtered.length + ' active \u00b7 ' + formatPrice(Math.round(viewTotal * 100) / 100) + (view === 'annual' ? '/yr' : '/mo');

    var totalMo = 0, totalYr = 0;
    subs.forEach(function(s){ totalMo += monthlyPrice(s); totalYr += annualPrice(s); });
    var grand = document.getElementById('ast-subs-grandtotal');
    if(grand){
      grand.textContent = 'Total ' + formatPrice(Math.round(totalMo * 100) / 100) + '/mo \u00b7 ' + formatPrice(Math.round(totalYr * 100) / 100) + '/yr';
      grand.style.display = subs.length ? '' : 'none';
    }

    document.querySelectorAll('.ast-subs-toggle-btn').forEach(function(btn){
      btn.classList.toggle('is-active', btn.getAttribute('data-view') === view);
    });

    var html = '';
    if(!subs.length){
      html = '<div class="ast-subs-empty">No subscriptions yet \u2014 tap + to add one</div>';
    } else if(!filtered.length){
      html = '<div class="ast-subs-empty">No ' + view + ' subscriptions</div>';
    } else {
      filtered.forEach(function(s){
        var i = subs.indexOf(s);
        var fav = s.url ? faviconUrl(s.url) : '';
        var favicon = fav
          ? '<img class="ast-subs-favicon" src="' + esc(fav) + '" alt="">'
          : '<span class="ast-subs-favicon-fallback">' + esc((s.name || '?')[0].toUpperCase()) + '</span>';
        html += '<div class="ast-subs-item" data-sub-idx="' + i + '">'
          + '<span class="ast-subs-drag" draggable="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="11" height="11"><circle cx="9" cy="5" r="1" fill="currentColor"/><circle cx="9" cy="12" r="1" fill="currentColor"/><circle cx="9" cy="19" r="1" fill="currentColor"/><circle cx="15" cy="5" r="1" fill="currentColor"/><circle cx="15" cy="12" r="1" fill="currentColor"/><circle cx="15" cy="19" r="1" fill="currentColor"/></svg></span>'
          + favicon
          + '<span class="ast-subs-name">' + esc(s.name || 'Untitled') + '</span>'
          + '<span class="ast-subs-cycle">' + (s.cycle === 'annual' ? 'annual' : 'monthly') + '</span>'
          + '<span class="ast-subs-price">' + formatPrice(parseFloat(s.price) || 0) + (s.cycle === 'annual' ? '/yr' : '/mo') + '</span>'
          + '<button class="ast-subs-edit" data-idx="' + i + '" data-tooltip="Edit">'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 113 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>'
          + '</button>'
          + '<button class="ast-subs-del" data-idx="' + i + '" data-tooltip="Remove">'
          + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 12"/></svg>'
          + '</button>'
          + '</div>';
      });
    }
    container.innerHTML = html;
  }

  function syncSave(){
    var row = document.getElementById('ast-subs-add-row');
    if(!row) return;
    var u = document.getElementById('ast-subs-url-input');
    var pr = document.getElementById('ast-subs-price-input');
    var has = !!((u && u.value.trim()) || (pr && pr.value.trim()));
    row.classList.toggle('has-content', has);
  }

  function addSub(){
    var projectId = pid();
    if(!projectId) return;
    var u = document.getElementById('ast-subs-url-input');
    var pr = document.getElementById('ast-subs-price-input');
    var cy = document.getElementById('ast-subs-cycle-select');
    var url = u ? u.value.trim() : '';
    var price = pr ? pr.value.trim() : '';
    var cycle = cy ? cy.value : 'monthly';
    if(!url) return;
    if(!/^https?:\/\//i.test(url)) url = 'https://' + url;
    var subs = getSubs(projectId);
    subs.push({
      id: Date.now().toString(36),
      name: url.replace(/^https?:\/\//, '').split('/')[0],
      url: url,
      price: price || '0',
      cycle: cycle
    });
    saveSubs(projectId, subs);
    if(u) u.value = '';
    if(pr) pr.value = '';
    var row = document.getElementById('ast-subs-add-row');
    if(row){ row.classList.remove('is-open'); row.classList.remove('has-content'); }
    renderSubs(projectId);
    if(window.astWsScroll) window.astWsScroll('subscriptions');
  }

  function scrollElToTop(el, cb){
    var bodyEl = document.querySelector('.atk-workspace__body');
    if(!bodyEl || !el){ if(cb) cb(); return; }
    var r = el.getBoundingClientRect();
    var br = bodyEl.getBoundingClientRect();
    var target = bodyEl.scrollTop + (r.top - br.top) - 90;
    var start = bodyEl.scrollTop;
    var dist = target - start;
    if(Math.abs(dist) < 4){ if(cb) cb(); return; }
    var dur = 350, t0 = null;
    function step(ts){
      if(!t0) t0 = ts;
      var pr = Math.min((ts - t0) / dur, 1);
      bodyEl.scrollTop = start + dist * (1 - Math.pow(1 - pr, 3));
      if(pr < 1){ requestAnimationFrame(step); } else if(cb){ cb(); }
    }
    requestAnimationFrame(step);
  }

  function openSubEdit(item, idx){
    var projectId = pid();
    if(!projectId || !item || isNaN(idx)) return;
    if(document.querySelector('.ast-subs-item.is-editing')){
      renderSubs(projectId);
      item = document.querySelector('#ast-subs-container [data-sub-idx="' + idx + '"]');
      if(!item) return;
    }
    var subs = getSubs(projectId);
    var sub = subs[idx];
    if(!sub) return;
    item.classList.add('is-editing');
    item.innerHTML = ''
      + '<input class="ast-subs-input" data-esub-url value="' + esc(sub.url || '') + '" placeholder="Enter Subscription URL">'
      + '<input class="ast-subs-input ast-subs-input--price" data-esub-price type="number" min="0" step="0.01" value="' + esc(sub.price || '') + '" placeholder="$0.00">'
      + '<select class="ast-subs-cycle-select" data-esub-cycle>'
      + '<option value="monthly"' + (sub.cycle !== 'annual' ? ' selected' : '') + '>/ mo</option>'
      + '<option value="annual"' + (sub.cycle === 'annual' ? ' selected' : '') + '>/ yr</option>'
      + '</select>'
      + '<button type="button" class="ast-subs-save-btn ast-subs-save-btn--inline" data-esub-save="' + idx + '">Save</button>';
    scrollElToTop(item, function(){
      var urlInp = item.querySelector('[data-esub-url]');
      if(urlInp) urlInp.focus({ preventScroll: true });
    });
  }

  /* ── delegated events (survive re-renders and workspaces reopening) ── */
  document.addEventListener('click', function(e){
    var t = e.target;
    if(!t.closest) return;
    var tog = t.closest('.ast-subs-toggle-btn');
    if(tog){ SUB_VIEW = tog.getAttribute('data-view'); renderSubs(pid()); return; }
    if(t.closest('#ast-subs-add-toggle')){
      var row = document.getElementById('ast-subs-add-row');
      if(!row) return;
      var open = row.classList.toggle('is-open');
      if(open){
        scrollElToTop(row, function(){
          var u = document.getElementById('ast-subs-url-input');
          if(u) u.focus({ preventScroll: true });
        });
      }
      return;
    }
    if(t.closest('#ast-subs-add-btn')){ addSub(); return; }
    var editBtn = t.closest('.ast-subs-edit');
    if(editBtn){
      e.stopPropagation();
      openSubEdit(editBtn.closest('.ast-subs-item'), parseInt(editBtn.getAttribute('data-idx'), 10));
      return;
    }
    var editSave = t.closest('[data-esub-save]');
    if(editSave){
      e.stopPropagation();
      var projectIdS = pid();
      if(!projectIdS) return;
      var idxS = parseInt(editSave.getAttribute('data-esub-save'), 10);
      var subsS = getSubs(projectIdS);
      if(!subsS[idxS]) return;
      var item2 = editSave.closest('.ast-subs-item');
      var uv = (item2.querySelector('[data-esub-url]') || {}).value || '';
      var pv = (item2.querySelector('[data-esub-price]') || {}).value || '';
      var cv = (item2.querySelector('[data-esub-cycle]') || {}).value || 'monthly';
      uv = uv.trim(); pv = pv.trim();
      if(!uv) return;
      if(!/^https?:\/\//i.test(uv)) uv = 'https://' + uv;
      subsS[idxS] = {
        id: subsS[idxS].id,
        name: uv.replace(/^https?:\/\//, '').split('/')[0],
        url: uv,
        price: pv || '0',
        cycle: cv
      };
      saveSubs(projectIdS, subsS);
      renderSubs(projectIdS);
      if(window.astWsScroll) window.astWsScroll('subscriptions');
      return;
    }
    var rowEl = t.closest('.ast-subs-item');
    if(rowEl && rowEl.closest('#ast-subs-container') && !rowEl.classList.contains('is-editing')
       && !t.closest('.ast-subs-del') && !t.closest('.ast-subs-drag')){
      openSubEdit(rowEl, parseInt(rowEl.getAttribute('data-sub-idx'), 10));
      return;
    }
    var del = t.closest('.ast-subs-del');
    if(del){
      e.stopPropagation();
      var projectId = pid();
      if(!projectId) return;
      var idx = parseInt(del.getAttribute('data-idx'), 10);
      var subs = getSubs(projectId);
      if(isNaN(idx) || idx < 0 || idx >= subs.length) return;
      subs.splice(idx, 1);
      saveSubs(projectId, subs);
      renderSubs(projectId);
      return;
    }
  });

  document.addEventListener('input', function(e){
    if(e.target.closest && e.target.closest('#ast-subs-add-row')) syncSave();
  });

  document.addEventListener('keydown', function(e){
    if(e.key !== 'Enter' || !e.target.closest || e.target.tagName !== 'INPUT') return;
    if(e.target.closest('#ast-subs-add-row')){
      e.preventDefault();
      addSub();
      return;
    }
    var editing = e.target.closest('.ast-subs-item.is-editing');
    if(editing){
      e.preventDefault();
      var saveBtn = editing.querySelector('[data-esub-save]');
      if(saveBtn) saveBtn.click();
    }
  });

  /* ── item drag-and-drop reorder ── */
  var subsDragIdx = null;
  document.addEventListener('dragstart', function(e){
    var h = e.target.closest && e.target.closest('.ast-subs-drag');
    if(!h) return;
    var item = h.closest('.ast-subs-item');
    if(!item) return;
    subsDragIdx = parseInt(item.getAttribute('data-sub-idx'), 10);
    item.classList.add('dragging');
    e.dataTransfer.effectAllowed = 'move';
    try{ e.dataTransfer.setData('text/plain', 'sub'); }catch(err){}
  });
  document.addEventListener('dragend', function(){
    if(subsDragIdx === null) return;
    document.querySelectorAll('.ast-subs-item').forEach(function(el){ el.classList.remove('dragging','drag-over'); });
    subsDragIdx = null;
  });
  document.addEventListener('dragover', function(e){
    if(subsDragIdx === null) return;
    var over = e.target.closest && e.target.closest('.ast-subs-item');
    if(!over || !over.closest('#ast-subs-container')) return;
    e.preventDefault();
    document.querySelectorAll('.ast-subs-item').forEach(function(el){ el.classList.remove('drag-over'); });
    if(parseInt(over.getAttribute('data-sub-idx'), 10) !== subsDragIdx) over.classList.add('drag-over');
  });
  document.addEventListener('drop', function(e){
    if(subsDragIdx === null) return;
    var over = e.target.closest && e.target.closest('.ast-subs-item');
    if(!over || !over.closest('#ast-subs-container')) return;
    e.preventDefault();
    var toIdx = parseInt(over.getAttribute('data-sub-idx'), 10);
    if(isNaN(toIdx) || toIdx === subsDragIdx) return;
    var projectId = pid();
    if(!projectId) return;
    var subs = getSubs(projectId);
    var moved = subs.splice(subsDragIdx, 1)[0];
    subs.splice(toIdx, 0, moved);
    saveSubs(projectId, subs);
    renderSubs(projectId);
  });

  /* Keep the existing template call-site working */
  window.astInitSubsModule = function(projectId){ renderSubs(projectId || pid()); };
  window.astRenderSubs = renderSubs;

  /* ── inject markup (matches the current module header pattern) ── */
  function injectSubsHtml(){
    var placeholder = document.getElementById('ast-subs-module-placeholder');
    if(!placeholder) return;
    placeholder.innerHTML = [
      '<div class="atk-workspace__section-label" style="justify-content:space-between">',
        '<span class="atk-ws-module-titlewrap" style="display:flex;align-items:center;gap:7px">',
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>',
          '<span class="atk-ws-module-title" data-ws-module-title="subscriptions" contenteditable="true" spellcheck="false">Subscriptions</span>',
        '</span>',
        '<span class="ast-subs-meta">',
          '<span class="ast-subs-toggle">',
            '<button type="button" class="ast-subs-toggle-btn is-active" data-view="monthly">Monthly</button>',
            '<button type="button" class="ast-subs-toggle-btn" data-view="annual">Annual</button>',
          '</span>',
          '<span class="ast-subs-total-badge" id="ast-subs-total-badge">0 active \u00b7 $0/mo</span>',
          '<span class="ast-subs-grandtotal" id="ast-subs-grandtotal" style="display:none">Total $0/mo \u00b7 $0/yr</span>',
        '</span>',
        '<span class="atk-ws-module-actions">',
          '<button class="atk-ws-add-section-btn" id="ast-subs-add-toggle" data-tooltip="Add subscription"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="13" height="13"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>',
          '<button class="atk-ws-module-remove" data-ws-module-remove="subscriptions" data-tooltip="Remove module"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="13" height="13"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>',
        '</span>',
      '</div>',
      '<div class="ast-subs-list" id="ast-subs-container"></div>',
      '<div class="ast-subs-add-row" id="ast-subs-add-row">',
        '<input id="ast-subs-url-input" class="ast-subs-input" type="text" placeholder="Enter Subscription URL">',
        '<input id="ast-subs-price-input" class="ast-subs-input ast-subs-input--price" type="number" min="0" step="0.01" placeholder="$0.00">',
        '<select id="ast-subs-cycle-select" class="ast-subs-cycle-select">',
          '<option value="monthly">/ mo</option>',
          '<option value="annual">/ yr</option>',
        '</select>',
        '<button id="ast-subs-add-btn" class="ast-subs-save-btn" type="button">Save</button>',
      '</div>'
    ].join('');

    /* Re-render whenever the section becomes visible (workspace opened / module added) */
    var mo = new MutationObserver(function(){
      if(placeholder.style.display !== 'none') renderSubs(pid());
    });
    mo.observe(placeholder, { attributes: true, attributeFilter: ['style'] });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', injectSubsHtml);
  } else {
    injectSubsHtml();
  }
})();
